import { useCallback, useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { setAdd, setRemove } from 'utils/array'

export const SEPARATOR = '.' // also ok: ~ *

export const DEFAULT_QUERYS = {
  querys: Object.freeze({
    search: '',
    r: [],
    q: [],
    c: [],
    parsed: new URLSearchParams()
  })
}

export function useUpdateQuerys(Context, type) {
  const [{ querys }, dispatch] = useContext(Context)

  const search = useLocation().search

  useEffect(() => {
    if (querys.search !== search) {
      const parsed = new URLSearchParams(search)
      const q = (parsed.get('q')?.split(SEPARATOR) || []).filter((i) => i)
      const r = (parsed.get('r')?.split(SEPARATOR) || []).filter((i) => i)
      const c = (parsed.get('c')?.split(SEPARATOR) || []).filter((i) => i)
      dispatch({ type, q, r, c, search, parsed })
    }
  }, [dispatch, querys, type, search])
}

export function useExpandQuerys(querys, tok) {
  const navigate = useNavigate()
  const pivot = useCallback(
    (id) => {
      const query = querys.parsed
      const expand = querys[tok] || []
      if (expand.includes(id)) {
        query.set(tok, setRemove(expand, id).join('.'))
      } else {
        query.set(tok, setAdd(expand, id).join('.'))
      }
      navigate(window.location.pathname + '?' + query.toString())
    },
    [navigate, querys, tok]
  )

  return { pivot, expand: querys[tok] }
}
